export default __webpack_public_path__ + "static/jesseBerwald@2x-a1c749c08a505b91a50c9d5b2d4b47b0.jpg";